module.exports = __webpack_public_path__ + "static/media/banner-resgate-de-dominio-gratuito-mobile.297de5e1.png";